import { render, staticRenderFns } from "./QuestionFileItem.vue?vue&type=template&id=ecd60ff2"
import script from "./QuestionFileItem.vue?vue&type=script&lang=ts"
export * from "./QuestionFileItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports